import { render, staticRenderFns } from "./ChatbotMessageItem.vue?vue&type=template&id=54745fa4&scoped=true&"
import script from "./ChatbotMessageItem.vue?vue&type=script&lang=js&"
export * from "./ChatbotMessageItem.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotMessageItem.vue?vue&type=style&index=0&id=54745fa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54745fa4",
  null
  
)

export default component.exports